export default "__VITE_ASSET__Dbol2qgr__"